 

 
const TitleContainer = ({title}) => {
 
 
  return (
    <h2 className={"header H2"}>
            {title}
    </h2>
  );
}

export default TitleContainer
